<template>
    <ion-header>
        <ion-toolbar>
            <ion-buttons slot="start">
                <ion-button color="medium" @click="cancel">Annulla</ion-button>
            </ion-buttons>
            <ion-title>{{ title }}</ion-title>
            <ion-buttons slot="end">
                <ion-button @click="submit" :strong="true">Conferma</ion-button>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding" style="--background: var(--ion-item-background)">
        <ion-header collapse="condense">
            <ion-toolbar style="--background: var(--ion-item-background)">
                <ion-title slot="start" class="w-full text-left" style="padding-inline: 0">
                    <h1 class="font-bold">
                        {{ title }}
                    </h1>
                </ion-title>
            </ion-toolbar>
        </ion-header>
        <form class="">
            <form-input
                v-model="businessName"
                v-model:valid="businessNameValid"
                :rules="[Validation.required]"
                label="Ragione sociale"></form-input>
            <form-input
                v-model="city"
                v-model:valid="cityValid"
                :rules="[Validation.required]"
                label="Città"></form-input>
            <ion-nav-link router-direction="forward" :component="MapAutocomplete" :component-props="cleanedData">
                <form-input
                    v-model="address"
                    v-model:valid="addressValid"
                    :readonly="true"
                    :rules="[Validation.required]"
                    label="Indirizzo"></form-input>
            </ion-nav-link>
            <div :style="`display: ${latitude && longitude ? 'block' : 'none'}`" class="w-full ion-margin-top-half">
                <map-box :center="center" height="200px" :markers-data="markers"></map-box>
            </div>
            <template v-if="!latitude || !longitude">
                <div
                    class="w-full rounded flex justify-center ion-align-items-center"
                    style="height: 200px; background-color: var(--ion-color-step-350)">
                    <ion-text><em>Nessuna posizione impostata</em></ion-text>
                </div>
            </template>
            <!--            <form-input v-model="email" v-model:valid="emailValid" :rules="[Validation.email]" label="Indirizzo email"></form-input>-->
            <div
                class="w-full ion-margin-vertical flex ion-align-items-center"
                style="background-color: var(--ion-color-step-150); padding: 8px; border-radius: 8px">
                <div style="flex-grow: 1">
                    <small class="block">Frequenza delle ispezioni</small>
                    <span v-if="interventionFrequency" class="block ion-margin-top-half">
                        {{ interventionFrequency.description }}:
                        {{ interventionFrequency.recent_inspection_interval }} -
                        {{ interventionFrequency.regular_situation_interval }} -
                        {{ interventionFrequency.expiring_situation_interval }}
                    </span>
                    <span v-else class="block w-full ion-margin-top-half">
                        <ion-note><em>Non è stata impostata una frequenza per le ispezioni</em></ion-note>
                    </span>
                </div>
                <div>
                    <ion-nav-link
                        router-direction="forward"
                        :component="InterventionFrequencySelection"
                        :component-props="cleanedData">
                        <ion-button @click="" fill="clear" style="--padding-start: 0; --padding-end: 0; height: auto">
                            <ion-icon :icon="chevronDownOutline"></ion-icon>
                        </ion-button>
                    </ion-nav-link>
                </div>
            </div>
            <div
                class="w-full ion-margin-vertical"
                style="background-color: var(--ion-color-step-150); padding: 8px; border-radius: 8px">
                <div class="w-full flex justify-between items-center">
                    <div>
                        <ion-label>Indirizzi email</ion-label>
                    </div>
                    <div>
                        <ion-button
                            @click="addEmailAddress"
                            fill="clear"
                            style="--padding-start: 0; --padding-end: 0; height: auto">
                            <ion-icon :icon="add"></ion-icon>
                        </ion-button>
                    </div>
                </div>
                <template v-if="emailAddresses.length > 0">
                    <ion-list style="background: transparent" class="ion-margin-top-half">
                        <ion-item
                            v-for="email in emailAddresses"
                            style="--background: transparent; --padding-start: 0; --inner-padding-end: 0">
                            <ion-label style="margin-top: 4px; margin-bottom: 4px">
                                <small>{{ email }}</small>
                            </ion-label>
                            <ion-buttons slot="end">
                                <ion-button fill="clear" @click="removeEmailAddress(email)">
                                    <ion-icon color="danger" :icon="removeCircleOutline"></ion-icon>
                                </ion-button>
                            </ion-buttons>
                        </ion-item>
                    </ion-list>
                </template>
                <div class="" v-else>
                    <ion-note>
                        <small><em>Nessun indirizzo email</em></small>
                    </ion-note>
                </div>
            </div>
            <div
                class="w-full ion-margin-vertical"
                style="background-color: var(--ion-color-step-150); padding: 8px; border-radius: 8px">
                <div class="w-full flex justify-between items-center">
                    <div>
                        <ion-label>Infestanti monitorati</ion-label>
                    </div>
                    <div>
                        <ion-button
                            @click="addPestAnimalAlert"
                            fill="clear"
                            style="--padding-start: 0; --padding-end: 0; height: auto">
                            <ion-icon :icon="add"></ion-icon>
                        </ion-button>
                    </div>
                </div>
                <template v-if="pestAnimals.length > 0">
                    <ion-list style="background: transparent" class="ion-margin-top-half">
                        <ion-item
                            v-for="pestAnimal in pestAnimals"
                            style="--background: transparent; --padding-start: 0; --inner-padding-end: 0">
                            <ion-label style="margin-top: 4px; margin-bottom: 4px">
                                <small>{{ pestAnimal }}</small>
                            </ion-label>
                            <ion-buttons slot="end">
                                <ion-button fill="clear" @click="removePestAnimal(pestAnimal)">
                                    <ion-icon color="danger" :icon="removeCircleOutline"></ion-icon>
                                </ion-button>
                            </ion-buttons>
                        </ion-item>
                    </ion-list>
                </template>
                <div class="" v-else>
                    <ion-note>
                        <small><em>Nessun infestante monitorato</em></small>
                    </ion-note>
                </div>
            </div>
            <div
                class="w-full ion-margin-vertical"
                style="background-color: var(--ion-color-step-150); padding: 8px; border-radius: 8px">
                <div class="w-full flex justify-between items-center">
                    <div>
                        <ion-label>Aree monitorate</ion-label>
                    </div>
                    <div>
                        <ion-button
                            @click="addAreaAlert"
                            fill="clear"
                            style="--padding-start: 0; --padding-end: 0; height: auto">
                            <ion-icon :icon="add"></ion-icon>
                        </ion-button>
                    </div>
                </div>
                <template v-if="areas.length > 0">
                    <ion-list style="background: transparent" class="ion-margin-top-half">
                        <ion-item
                            v-for="area in areas"
                            style="--background: transparent; --padding-start: 0; --inner-padding-end: 0">
                            <ion-label style="margin-top: 4px; margin-bottom: 4px">
                                <small>{{ area }}</small>
                            </ion-label>
                            <ion-buttons slot="end">
                                <ion-button fill="clear" @click="removeArea(area)">
                                    <ion-icon color="danger" :icon="removeCircleOutline"></ion-icon>
                                </ion-button>
                            </ion-buttons>
                        </ion-item>
                    </ion-list>
                </template>
                <div class="" v-else>
                    <ion-note>
                        <small><em>Nessuna area monitorata</em></small>
                    </ion-note>
                </div>
            </div>
        </form>
    </ion-content>
</template>

<script setup lang="ts">
import {
    IonButton,
    IonButtons,
    IonContent,
    IonIcon,
    IonHeader,
    IonText,
    IonNote,
    IonList,
    IonItem,
    IonLabel,
    IonTitle,
    IonToolbar,
    alertController,
    modalController,
    toastController,
    IonNavLink,
} from "@ionic/vue";
import FormInput from "@/components/FormInput.vue";
import { computed, markRaw, onMounted, PropType, reactive, ref } from "vue";
import { add, removeCircleOutline, chevronDownOutline } from "ionicons/icons";
import { ICostumer } from "@/types/costumer";
import { useCostumersStore } from "@/stores/costumers";
import { Validation } from "@/utility";
import MapAutocomplete from "@/components/modals/MapAutocomplete.vue";
import MapBox from "@/components/MapBox.vue";
import { useInterventionFrequencyStore } from "@/stores/interventionFrequencies";
import InterventionFrequencySelection from "@/components/modals/InterventionFrequencySelection.vue";
import MarkerOptions = google.maps.MarkerOptions;
import LatLngLiteral = google.maps.LatLngLiteral;
import { IExtendedMarkerOptions } from "@/types/maps";

const props = defineProps({
    costumer: {
        type: Object as PropType<ICostumer>,
        required: false,
    },
});

const costumerId = props.costumer ? props.costumer.id : -Math.round(Date.now() / 1000);
const costumerStore = useCostumersStore();
const interventionFrequencyStore = useInterventionFrequencyStore();
const businessName = ref<string>(props.costumer?.business_name ?? "");
const businessNameValid = ref<boolean>(props.costumer ? !!props.costumer.business_name : true);
const city = ref<string>(props.costumer?.city ?? "");
const address = ref<string>(props.costumer?.address ?? "");
const cityValid = ref<boolean>(props.costumer ? !!props.costumer.city : true);
const addressValid = ref<boolean>(props.costumer ? !!props.costumer.address : true);
const email = ref<string>(props.costumer?.email ?? "");
const emailAddresses = reactive<string[]>(props.costumer?.email?.split(", ") ?? []);
const pestAnimals = reactive<string[]>(props.costumer?.pest_animals ?? []);
const areas = reactive<string[]>(props.costumer?.areas ?? []);
const latitude = ref<undefined | number>(props.costumer?.latitude);
const longitude = ref<undefined | number>(props.costumer?.longitude);
const interventionFrequencyId = ref<number | undefined>(props.costumer?.intervention_frequency ?? undefined);
const interventionFrequency = computed(() =>
    interventionFrequencyId.value
        ? interventionFrequencyStore.getInterventionFrequencyById(interventionFrequencyId.value)
        : undefined
);

const addEmailAddress = async () => {
    const alert = await alertController.create({
        header: `Aggiungi indirizzo email`,
        inputs: [
            {
                placeholder: "Indirizzo email",
                value: "",
                attributes: {
                    type: "email",
                },
            },
        ],
        buttons: [
            {
                text: "Annulla",
                role: "cancel",
                handler: () => {},
            },
            {
                text: "Aggiungi",
                role: "confirm",
                handler: (value: string) => {
                    if (Validation.email(value[0]) !== null) {
                        toastController
                            .create({
                                message: "Indirizzo email non valido",
                                duration: 3000,
                                position: "bottom",
                                color: "danger",
                            })
                            .then((toast) => toast.present());
                        return false;
                    } else {
                        emailAddresses.push(value[0]);
                    }
                },
            },
        ],
    });

    await alert.present();
};
const addPestAnimalAlert = async () => {
    const alert = await alertController.create({
        header: `Aggiungi specie infestante monitorata`,
        inputs: [
            {
                placeholder: "Infestante",
                value: "",
            },
        ],
        buttons: [
            {
                text: "Annulla",
                role: "cancel",
                handler: () => {},
            },
            {
                text: "Aggiungi",
                role: "confirm",
                handler: (value: any) => {
                    if ((value[0] as string).length > 0) {
                        pestAnimals.push(value[0]);
                    }
                },
            },
        ],
    });

    await alert.present();
};
const addAreaAlert = async () => {
    const alert = await alertController.create({
        header: `Aggiungi area monitorata`,
        inputs: [
            {
                placeholder: "Area",
                value: "",
            },
        ],
        buttons: [
            {
                text: "Annulla",
                role: "cancel",
                handler: () => {},
            },
            {
                text: "Aggiungi",
                role: "confirm",
                handler: (value: any) => {
                    if ((value[0] as string).length > 0) {
                        areas.push(value[0]);
                    }
                },
            },
        ],
    });

    await alert.present();
};
const removePestAnimal = (value: string) => {
    const index = pestAnimals.findIndex((pest) => pest === value);
    if (index >= 0) {
        pestAnimals.splice(index, 1);
    }
};
const removeEmailAddress = (value: string) => {
    const index = emailAddresses.findIndex((address) => address === value);
    if (index >= 0) {
        emailAddresses.splice(index, 1);
    }
};
const removeArea = (value: string) => {
    const index = areas.findIndex((area) => area === value);
    if (index >= 0) {
        areas.splice(index, 1);
    }
};

const center = computed(() => {
    if (latitude.value && longitude.value) {
        return {
            lat: Number(latitude.value),
            lng: Number(longitude.value),
        } as LatLngLiteral;
    }
    return undefined;
});
const markers = computed(() => [{ position: center.value } as IExtendedMarkerOptions]);
const cleanedData = computed(() =>
    markRaw({
        costumer: {
            id: costumerId,
            business_name: businessName.value,
            email: emailAddresses.join(", "),
            city: city.value,
            address: address.value,
            latitude: latitude.value,
            longitude: longitude.value,
            areas: areas,
            pest_animals: pestAnimals,
            inspections: props.costumer?.inspections ?? [],
            intervention_frequency: interventionFrequencyId.value,
        } as ICostumer,
    })
);
const title = computed(() => {
    return costumerId >= 0 ? "Modifica cliente" : "Aggiungi cliente";
});

const cancel = () => {
    return modalController.dismiss(null, "cancel");
};
const submit = () => {
    const costumer: ICostumer = cleanedData.value.costumer;
    if (costumerId >= 0) {
        costumerStore.updateCostumer(costumer);
    } else {
        costumerStore.createCostumer(costumer);
    }
    return modalController.dismiss(null, "confirm");
};
</script>
